import { connect } from 'react-redux';
import View from './View';
import * as selector from '../../TransactionsSelector';
import { currentClientIdSelector } from '../../../CommonSelectors/CommonAreaSelector';
import {
  closeModal,
  clearErrors,
  deleteTransaction,
} from '../../TransactionsActions';

const mapStateToProps = state => ({
  clientId: currentClientIdSelector(state),
  errors: selector.errors(state),
  isOpen: selector.isDeleteModalOpen(state),
  draftTransaction: selector.draftTransaction(state),
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => (
    dispatch(closeModal())
  ),
  clearErrors: () => (
    dispatch(clearErrors())
  ),
  deleteTransaction: (...args) => (
    dispatch(deleteTransaction(...args))
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
